<template>
    <Transition name="fade">
        <div v-if="show" class="similar-popup-overlay" @click="handleClose">
            <div class="similar-popup-content" @click.stop>
                <div class="similar-popup-header mb-20px">
                    <div class="text-16px font-800 color-#fff mt-20px">You might also like</div>
                    <div class="close-btn" @click="handleClose">
                        <img src="@/assets/images/message/close.svg" class="w-24px h-24px" alt="close" />
                    </div>
                </div>

                <div class="similar-list mb-50px">
                    <div v-for="(item, index) in festivalList" :key="index" class="similar-item relative"
                        @click="handleItemClick(item)">
                        <img :src="item.background" class="w-120px h-160px object-cover rounded-10px overflow-hidden"
                            alt="avatar" />
                        <div
                            class="text-14px font-900 mt-10px max-w-100px overflow-hidden whitespace-nowrap text-ellipsis">
                            {{ item.name }}
                        </div>
                        <div class="absolute top-8px left-6px gap-3px flex flex items-center justify-center info">
                            <img src="@/assets/images/home/info.svg" class="w-full h-full" />
                            <div class="text-9px color-#fff font-400">
                                {{ (item.chatCount / 1000).toFixed(2) }}k
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom-bg">

                </div>
                <div class="bottom-btn">
                    <div class="text-14px font-900 leave" @click="() => {
                        router.replace({ path: route.query?.route as string })
                    }">
                        Leave
                    </div>
                    <div class="text-14px font-900 chatting" @click="handleClose">
                        Keep chatting
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { HomeAPI } from '@/services/home'
import { useRouter, useRoute } from 'vue-router'
import { ref, onMounted } from 'vue'

const festivalList = ref<any[]>([])

interface SimilarItem {
    id?: any
    name?: string
    avatar?: string
    intro?: string
    [key: string]: any
}

interface Props {
    show: boolean
    id: number
    list?: SimilarItem[]
}

const props = withDefaults(defineProps<Props>(), {
    show: false,
    id: 0,
    list: () => []
})

const emit = defineEmits<{
    (e: 'update:show', value: boolean): void
    (e: 'select', item: SimilarItem): void
    (e: 'back'): void
}>()

const router = useRouter()
const route = useRoute()

const defaultAvatar = '/assets/images/discover/dome.png'

const handleClose = () => {
    emit('update:show', false)
}

const handleItemClick = (item: SimilarItem) => {
    console.log(route.query?.path,'route.query?.path');
    
    router.replace({
        path: '/chat', query: {
            preData: encodeURIComponent(JSON.stringify(item)),
            path: route.query?.route as string
        }
    })
}

const getSimilarRole = async (id: any) => {
    const res = await HomeAPI.getSimilarRole({
        roleId: id
    })
    festivalList.value = res.data
}

onMounted(() => {
    console.log(route.query);
    if (route.query.preData) {
        const preData = JSON.parse(decodeURIComponent(route.query.preData as string))
        getSimilarRole(preData.id)

    }
})
</script>

<style scoped lang="scss">
.similar-popup-overlay {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2000;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background: #1B1E33;
    backdrop-filter: blur(4px);
    border-radius: 20px 20px;
    width: 80%;
}

.similar-popup-content {
    width: 100%;
    max-height: 70vh;
    background: #1B1E33;
    border-radius: 20px 20px;
    padding-top: 10px !important;
    padding: 20px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-y;
}

.similar-popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // margin-bottom: 20px;
}

.close-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
}

.similar-list {
    height: 400px;
    overflow: hidden;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.similar-item {
    // display: flex;
    // align-items: center;
    // padding: 12px;
    // background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    cursor: pointer;
    transition: background 0.2s;

    &:active {
        background: rgba(255, 255, 255, 0.1);
    }

    margin-bottom: 30px;
}

.avatar {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    object-fit: cover;
    flex-shrink: 0;
}

.item-info {
    flex: 1;
    margin-left: 12px;
    overflow: hidden;
}

.bottom-bg {
    background: linear-gradient(180deg, rgba(27, 30, 51, 0) 0%, #1B1E33 50%, #1B1E33 100%);
    height: 140px;
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
    border-radius: 0 0 20px 20px;
}

.bottom-btn {
    position: absolute;
    bottom: 30px;
    left: 0;
    display: flex;
    justify-content: space-around;
    width: 100%;

    .leave {
        border: 1px solid #61636E;
        padding: 8px 20px;
        border-radius: 25px;
        font-weight: 500;
        font-size: 14px;
        color: #B3B4BB;
    }

    .chatting {
        background: linear-gradient(0deg, #5A68FF 0%, #95A5FF 100%);
        border-radius: 23px;
        padding: 8px 35px;
    }
}

.item-name {
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.item-intro {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.arrow-icon {
    margin-left: 12px;
    flex-shrink: 0;
}

.empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(100%);
}

.rotate-90 {
    transform: rotate(-90deg);
}

.info {
    padding: 4px 6px;
    height: 18px;
    background: rgba(1, 3, 27, 0.7);
    border-radius: 3px;
}
</style>
